var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import useUniqueId from "../../Hooks/useUniqueId";
import ListService from "../../../Services/Shared/List.service";
import { TermAttendanceStatusSearch } from "../../Presentational/TermAttendanceStatus/TermAttendanceStatusSearch";
import SearchField from "../../Form/SearchField";
import NumberService from "../../../Services/Shared/Number.service";
import TranscriptCourseService from "../../../Services/TranscriptCourse.service";
const MarkAsStoppedNeverAttendedModal = (_a) => {
    var { students, onSuccess } = _a, modalProps = __rest(_a, ["students", "onSuccess"]);
    const makeId = useUniqueId()[1];
    return (_jsxs(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Mark as Stopped/Never Attended", onSuccess: onSuccess, handleSubmit: (formState) => TranscriptCourseService.markTermAttendanceStatus(students.map((s) => s.transcriptCourseId), formState.termAttendanceStatus.id), children: [_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: makeId("students"), children: ["Students (", NumberService.format(students.length), ")"] }), _jsx("div", { id: makeId("students"), children: ListService.displayWithCommasAndAnd(students.map((student) => `${student.personFirstName} ${student.personLastName}`)) })] }), _jsx(SearchField, { label: "Term Attendance Status", name: "termAttendanceStatus", required: true, as: (provided) => _jsx(TermAttendanceStatusSearch, Object.assign({}, provided)) })] })));
};
export default MarkAsStoppedNeverAttendedModal;
